import { FC, MouseEventHandler } from 'react';

import { match, P } from 'ts-pattern';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { ProductSearchItem } from '../../model';
import { getFullProductUrl } from '../../utils/paths';
import { ProductCardSmall } from '../ProductCardSmall/ProductCardSmall';

type Props = {
    product: ProductSearchItem;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const ConnectedProductCardSmall: FC<Props> = ({ product, onClick }) => {
    const { t } = useTranslations();
    const segment = useSegment();

    const leasingCommitment = product.leasingCommitment;
    const commitment = match({ segment, leasingCommitment })
        .with({ segment: TeliaSegment.B2b }, () => product.commitment)
        .with({ leasingCommitment: P.not(P.nullish) }, () =>
            withParams(t['search.component.product_card.leasing_commitment'], { leasingCommitment }),
        )
        .otherwise(() => undefined);

    return (
        <ProductCardSmall
            key={product.id}
            name={product.name}
            image={product.img100x}
            imageAlt={product.imgAltText}
            monthlyPrice={product.monthlyPriceFormatted}
            fullPrice={product.fullPriceFormatted}
            oldFullPrice={product.oldFullPriceFormatted}
            residualValue={product.residualValueFormatted}
            commitment={commitment}
            badges={product.badges}
            url={getFullProductUrl(product.url, product.variantCode)}
            onClick={onClick}
        />
    );
};
